import { AxiosRequestConfig } from "axios";
import { FilteredListDto } from "../base/base.dto";
import http from "../base/http.service";
import {
  RiskDocumentAnswerDto,
  CreateRiskDocumentAnswerDto,
  UpdateRiskDocumentAnswerDto,
  RiskDocumentAnswerByApplicationUidDto,
} from "./risk-document-answers.dto";
//ApplicationRiskDocuments/by-application-uid/{applicationUid}
const services = {
  GetAll(config?: AxiosRequestConfig<any> | undefined) {
    return http.get<FilteredListDto<RiskDocumentAnswerDto>>(
      "ApplicationRiskDocuments",
      config
    );
  },
  Get(id: number, config?: AxiosRequestConfig<any> | undefined) {
    return http.get<RiskDocumentAnswerDto>(
      `ApplicationRiskDocuments/${id}`,
      config
    );
  },
  Add(
    dto: CreateRiskDocumentAnswerDto,
    config?: AxiosRequestConfig<any> | undefined
  ) {
    return http.post<RiskDocumentAnswerDto>(
      "ApplicationRiskDocuments",
      dto,
      config
    );
  },
  Delete(id: number, config?: AxiosRequestConfig<any> | undefined) {
    return http.remove<RiskDocumentAnswerDto>(
      `ApplicationRiskDocuments/${id}`,
      config
    );
  },
  Update(
    dto: UpdateRiskDocumentAnswerDto,
    config?: AxiosRequestConfig<any> | undefined
  ) {
    return http.put<RiskDocumentAnswerDto>(
      "ApplicationRiskDocuments",
      dto,
      config
    );
  },
  GetByApplicationID(
    applicationID: string,
    config?: AxiosRequestConfig<any> | undefined
  ) {
    return http.get<RiskDocumentAnswerByApplicationUidDto>(
      `ApplicationRiskDocuments/by-application-uid/${applicationID}`,
      config
    );
  },
  AddAnswer(
    dto: CreateRiskDocumentAnswerDto,
    config?: AxiosRequestConfig<any> | undefined
  ) {
    return http.post<RiskDocumentAnswerDto>(
      `ApplicationRiskDocuments/answer`,
      dto,
      config
    );
  },
  MoveToReview(
    applicationUid: string,
    config?: AxiosRequestConfig<any> | undefined
  ) {
    return http.post<RiskDocumentAnswerDto>(
      `ApplicationRiskDocuments/move-to-review/${applicationUid}`,
      config
    );
  },
  CompleteRiskEvaluation(
    applicationUid: string,
    config?: AxiosRequestConfig<any> | undefined
  ) {
    return http.post<RiskDocumentAnswerDto>(
      `ApplicationRiskDocuments/complete-evaluation/${applicationUid}`,
      config
    );
  },
};

export default services;
